import { useMemo } from 'react';
import { optionToEntityMap } from '../constants';
import { FormRadioGroup } from '~/components/FormComponents/FormRadioGroup';
import React from 'react';
import { FormInput } from '~/components/FormComponents/FormInput';
import { Grid } from '@mui/material';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete';
import { useAddressQuery } from '~/queries/useAddressQuery';
import { AddressInfo } from '~/modules/identification/components/FormComponents/AddressInfo';
import { useFormContext, useWatch } from 'react-hook-form';
import FormContainer from '~/modules/identification/components/FormComponents/FormContainer';
import { defaultFormAddress } from '~/modules/identification/constants';
import FormGridItem from '~/components/FormComponents/FormGridItem';

export const RelatedEntityInfo = React.memo(() => {
  const { nonAgressionCountryOptions } = useAddressQuery();
  const entity = useWatch({ name: 'relatedEntityInfo.entity' });
  const { setValue } = useFormContext();
  const radioOptions = useMemo(
    () => Object.values(optionToEntityMap).map((entity) => ({ label: entity, value: entity })),
    []
  );
  const showContent = entity !== optionToEntityMap.option0;

  const handleEntityChange = (value: string) => {
    if (value === optionToEntityMap.option0) {
      setValue('relatedEntityInfo', {
        entity: value,
      });
    } else if (entity === optionToEntityMap.option0) {
      setValue('relatedEntityInfo.address', defaultFormAddress, { shouldValidate: false });
    }
  };

  return (
    <FormContainer>
      <Grid size={12}>
        <FormRadioGroup
          name="relatedEntityInfo.entity"
          options={radioOptions}
          onChange={handleEntityChange}
        />
      </Grid>
      {showContent && (
        <>
          <FormGridItem>
            <FormInput
              name="relatedEntityInfo.fullName"
              label="Повне найменування підрозділу"
              placeholder="Введіть повне найменування підрозділу"
              fullWidth
            />
          </FormGridItem>
          <FormGridItem>
            <FormInput
              name="relatedEntityInfo.identificationNumber"
              inputProps={{
                maxLength: 10,
              }}
              label="Ідентифікаційний код за ЄДРПОУ/Реєстраційний номер"
              placeholder="Введіть ідентифікаційний код"
              fullWidth
            />
          </FormGridItem>
          <AddressInfo section="relatedEntityInfo" />
          <FormGridItem>
            <FormAutocomplete
              options={nonAgressionCountryOptions}
              name="relatedEntityInfo.residenceCountry"
              inputProps={{
                placeholder: 'Оберіть країну резидентності',
              }}
              label="Країна резидентності"
            />
          </FormGridItem>
        </>
      )}
    </FormContainer>
  );
});
